import { render } from "./WhiteboardModal.vue?vue&type=template&id=0f258dd2&scoped=true"
import script from "./WhiteboardModal.vue?vue&type=script&lang=js"
export * from "./WhiteboardModal.vue?vue&type=script&lang=js"

import "./WhiteboardModal.vue?vue&type=style&index=0&id=0f258dd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f258dd2"]])

export default __exports__